import { render, staticRenderFns } from "./AAA.vue?vue&type=template&id=3d88d5aa&scoped=true&"
import script from "./AAA.vue?vue&type=script&lang=js&"
export * from "./AAA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88d5aa",
  null
  
)

export default component.exports